/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    accept: {
        text: "Accepts"
    },
    defaultPickerTitle: "Upload files",
    fileExtensionError: {
        text: "Aborted: File extension is not allowed"
    },
    maxSizeError: {
        text: "Aborted : File size exceed limit of "
    },
    multipleError: {
        innerHTML: "Only one file expected"
    },
    sizeLimit: {
        text: "Size limit"
    },
    sizeUnit: {
        text: "MB"
    }
};